import { useState } from "react";
import { UserCog, UserPlus, ShieldOff, ShieldCheck } from "lucide-react";

export const StaffAccountsTab = ({ accounts, onCreate, onSetActive }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    const created = await onCreate(email.trim(), password);
    if (created) {
      setEmail("");
      setPassword("");
    }
  };

  return (
    <div className="space-y-6">
      <form onSubmit={submit} className="glass-card p-5">
        <div className="flex items-center gap-2 mb-4">
          <UserPlus className="w-5 h-5 text-[#D4AF37]" />
          <div>
            <h2 className="text-[#EDEDED] font-medium">Create Moderator</h2>
            <p className="text-xs text-[#71717A]">Moderators can review reports and listings, but cannot access users, revenue, payouts, or staff controls.</p>
          </div>
        </div>
        <div className="grid md:grid-cols-[1fr_1fr_auto] gap-3">
          <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="moderator@breedling.com" className="input-minimal" required />
          <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Temporary password (12+ characters)" minLength={12} className="input-minimal" required />
          <button type="submit" className="px-5 py-2 rounded-lg bg-[#D4AF37] text-black font-medium">Create</button>
        </div>
        <p className="text-xs text-[#71717A] mt-3">Send the temporary password privately. The password is salted and hashed before storage.</p>
      </form>

      <div className="glass-card overflow-hidden">
        <div className="p-4 border-b border-[#27272A] flex items-center gap-2">
          <UserCog className="w-5 h-5 text-[#A1A1AA]" />
          <h3 className="text-[#EDEDED]">Staff Accounts</h3>
        </div>
        {accounts.length === 0 ? (
          <p className="p-8 text-center text-[#71717A]">No moderator accounts created.</p>
        ) : (
          <div className="divide-y divide-[#27272A]">
            {accounts.map((account) => (
              <div key={account.email} className="p-4 flex items-center justify-between">
                <div>
                  <p className="text-[#EDEDED]">{account.email}</p>
                  <p className="text-xs text-[#71717A] capitalize">{account.role} · {account.is_active ? "Active" : "Disabled"}</p>
                </div>
                <button
                  onClick={() => onSetActive(account.email, !account.is_active)}
                  className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs ${account.is_active ? "bg-[#EF4444]/10 text-[#EF4444]" : "bg-[#22C55E]/10 text-[#22C55E]"}`}
                >
                  {account.is_active ? <ShieldOff className="w-4 h-4" /> : <ShieldCheck className="w-4 h-4" />}
                  {account.is_active ? "Disable" : "Enable"}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
